import FolioForm from "./components/FolioForm";

function App() {
  return (
    <main style={{ maxWidth: "1200px", margin: "0 auto" }}>
      <FolioForm />
    </main>
  );
}

export default App;